import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useRouteSession } from '@web/app'
import { ROUTES } from '@web/router'

export function hasName(session: { status: string; displayName?: string | null }): boolean {
	return typeof session.displayName === 'string' && session.displayName.trim() !== ''
}

export function OnboardingLayout() {
	const { state } = useRouteSession()
	const { pathname, search } = useLocation()

	if (state.status === 'ready') return <Navigate to={ROUTES.getStarted} replace />

	if (state.status === 'organisation' && pathname === ROUTES.onboardingOrganisation && !hasName(state)) {
		return <Navigate to={ROUTES.onboardingName} replace />
	}

	if (state.status === 'organisation' && pathname === ROUTES.onboardingName && hasName(state)) {
		return <Navigate to={ROUTES.onboardingOrganisation} replace />
	}

	if (state.status === 'anonymous') {
		return <Navigate to={`${ROUTES.signIn}?redirect=${encodeURIComponent(pathname + search)}`} replace />
	}

	if (state.status !== 'organisation') return null
	return <Outlet />
}
